import React from "react";
import cx from "./cx";

const SIZE_CLASS = { sm: 'rev-figure--sm', md: 'rev-figure--md', lg: 'rev-figure--lg', xl: 'rev-figure--xl' };

/**
 * Cifra destacada (métrica, contador, total). Sora 600 con cifras tabulares.
 *  - size: 'sm' (19) | undefined (23) | 'md' (24) | 'lg' (26) | 'xl' (30)
 *  - muted: sin dato («—»), color neutro
 */
const RevFigure = ({ as: As = 'span', size, muted, className, children, ...rest }) => (
    <As className={cx('rev-figure', SIZE_CLASS[size], 'rev-num', muted && 'rev-text-muted', className)} {...rest}>{children}</As>
);

export default RevFigure;
